import React from 'react';
import PropTypes from 'prop-types';
import LocationSelect from './index';

const propTypes = {
    cityId: PropTypes.string,
    onChange: PropTypes.func,
};

const LocationSelectField = ({
    input,
    parentId,
    onChange,
    label,
    disabled,
    placeHolder,
    isRequired,
    onItemChange,
    meta,
}) => {
    const { value: inputValue, onChange: inputOnChange } = input;

    const { error, warning } = meta;

    const handleChange = (value) => {
        inputOnChange(value);
        if (onChange) {
            onChange(value);
        }
    };
    return (
        <>
            <LocationSelect
                parentId={parentId}
                defaultValue={inputValue}
                label={label}
                onChange={(value) => handleChange(value)}
                disabled={disabled}
                placeHolder={placeHolder}
                isRequired={isRequired}
                onItemChange={onItemChange}
            />
            <div className="clearfix mb-10"></div>
            {(error && (
                <small className="text-danger text-validate">{error}</small>
            )) ||
                (warning && (
                    <small className="text-warning text-validate">
                        {warning}
                    </small>
                ))}
        </>
    );
};

LocationSelectField.propTypes = propTypes;

export default LocationSelectField;
